import { render, staticRenderFns } from "./AccessibleIcon.vue?vue&type=template&id=31e257ac&scoped=true&"
import script from "./AccessibleIcon.vue?vue&type=script&lang=js&"
export * from "./AccessibleIcon.vue?vue&type=script&lang=js&"
import style0 from "./AccessibleIcon.vue?vue&type=style&index=0&id=31e257ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e257ac",
  null
  
)

export default component.exports